import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { Notifications } from "@mantine/notifications";
import { useTranslation } from "react-i18next";
// dayjs ships English; Ukrainian month and weekday names have to be registered.
import "dayjs/locale/uk";

import { toLocale } from "@prostocheck/i18n";

import { DATES_SETTINGS, MANTINE_THEME } from "./mantine.constants";
import { IAppMantineProviderProps } from "./mantine.models";
import { resolveMantineCssVariables } from "./mantine.utils";

/**
 * Mantine supplies the interactive controls of the dashboard — inputs, pickers,
 * tables, overlays — while Tailwind keeps layout and the presentational parts
 * shared with the landing. The theme is not a second palette: it points at the
 * `libs/theme` tokens, so both halves render the same colours.
 *
 * Light only: the product has no dark mode, and forcing the scheme keeps
 * `ColorSchemeScript` (and its flash of the wrong theme) out of `index.html`.
 */
export const AppMantineProvider = ({ children }: IAppMantineProviderProps) => {
  const { i18n } = useTranslation();

  return (
    <MantineProvider
      theme={MANTINE_THEME}
      cssVariablesResolver={resolveMantineCssVariables}
      forceColorScheme="light"
    >
      <DatesProvider
        settings={{
          ...DATES_SETTINGS,
          locale: toLocale(i18n.resolvedLanguage),
        }}
      >
        <Notifications />
        {children}
      </DatesProvider>
    </MantineProvider>
  );
};
